import React, { useEffect, useRef, useState } from 'react'

import { Box } from '@material-ui/core'
import Spinner from '../../components/UI/Spinner/Spinner'

const LoadingMask = ({ show, children }) => {
  const boxRef = useRef(null)
  const [parentSize, setParentWidth] = useState({ width: '100%', height: '100%' })

  useEffect(() => {
    const boxEl = boxRef.current
    if (boxEl) {
      const parentNode = boxEl.parentNode
      const parentStyle = window.getComputedStyle(parentNode)
      const { width, height } = parentStyle
      setParentWidth({ width, height })
    }
  }, [boxRef, setParentWidth])

  if (!show) return children

  return (
    <>
      <Box
        ref={boxRef}
        position={'absolute'}
        zIndex={'tooltip'}
        {...parentSize}>
        <Spinner minHeight={'100%'} />
      </Box>
      <Box style={{ opacity: 0.6, width: '100%' }}>{children}</Box>
    </>
  )
}

export default LoadingMask
